export const getClassName = language => {
  return "LanguageButton__button--" + language;
};
